<template>
  <div>
    <v-carousel v-model="currentSlide" :height="carouselHeight" show-arrows="hover" hide-delimiter-background
      :cycle="false">
      <template v-if="items.length > 0">
        <v-carousel-item v-for="item in items" :key="item.contentId" ref="slides">
          <v-sheet class="pa-4" height="100%">
            <v-card outlined hover>
              <v-card-actions class="bg-aqua-teal" v-if="!noActions">
                <v-btn icon @click="favoriteHandler(item)">
                  <v-icon v-if="!isFavorited(item)"> mdi-heart </v-icon>
                  <v-icon v-else color="#ff6d44"> mdi-heart </v-icon>
                </v-btn>
              </v-card-actions>
              <v-card-title class="mont-font mont-bold text-left text-wrap text-center">
                {{ item.item }}
              </v-card-title>
              <v-card-text class="mont-font text-left">
                {{ item.itemDescription }}
              </v-card-text>
              <div v-if="isYouTubeLink(item.link)" class="d-flex justify-center pa-2 mb-4">
                <iframe height="250px" :width="videoWidth" :src="convertToEmbedLink(item.link)"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen></iframe>
              </div>
              
              <div class="d-flex justify-end pa-4" v-if="item.link">
                <v-btn
                  color="primary"
                  variant="text"
                  @click="openLink(item.link)"
                  class="mt-2"
                >
                  <v-icon left>mdi-open-in-new</v-icon>
                  Open Link
                </v-btn>
              </div>
            </v-card>
          </v-sheet>
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-sheet class="pa-4" height="100%">
            <v-card outlined>
              <v-card-title class="mont-font mont-bold text-center">
                No content available
              </v-card-title>
            </v-card>
          </v-sheet>
        </v-carousel-item>
      </template>
    </v-carousel>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      currentSlide: 0, // Track the current slide
      carouselHeight: 'auto', // Dynamically adjust height
      videoWidth: 'auto',  // Dynamically adjust video width
      favoriteMap: {},
      userFavorites: [],
      favoriteItem: {
        contentId: ""
      }
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    contentId: {
      type: String,
      required: false,
    }
  },
  methods: {
    isYouTubeLink(url) {
      const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/.*)?$/;
      return youtubeRegex.test(url);
    },
    convertToEmbedLink(watchLink) {
      if (watchLink.includes('youtube.com/watch?v=')) {
        return watchLink.replace('watch?v=', 'embed/');
      }
      console.error('Invalid YouTube watch link');
      return null;
    },
    updateCarouselHeight() {
      this.$nextTick(() => {
        if (this.$refs.slides && this.$refs.slides.length > 0) {
          const activeSlide = this.$refs.slides[this.currentSlide];
          if (activeSlide) {
            this.carouselHeight = `${activeSlide.offsetHeight}px`;
          } else {
            this.carouselHeight = 'auto';
          }
        } else {
          this.carouselHeight = 'auto';
        }
      });
    },
    updateVideoWidth() {
      this.videoWidth = `${window.innerWidth / 1.3}px`;
    },
    favoriteHandler(item) {
      var contentId = ""
      if (item.pageContentId != undefined) {
        contentId = item.pageContentId;
      } else {
        contentId = item.subPageContentId
      }
      if (this.favoriteMap[contentId]) {
        this.unfavorite(contentId)
      } else {
        this.favorite(contentId)
      }
    },
    async fetchFavorites() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        var response = await axios.get(`/api/favorite/user/${localStorage.getItem("patientId")}`);
        this.userFavorites = response.data;
        this.favoriteMap = {};
        this.userFavorites.forEach(favorite => {
          this.favoriteMap[favorite.contentID] = true;
        });
      } catch (error) {
        console.log(error);
      }
    },
    isFavorited(item) {
      var contentId = ""
      if (item.pageContentId != undefined) {
        contentId = item.pageContentId;
      } else {
        contentId = item.subPageContentId
      }
      return !!this.favoriteMap[contentId];
    },
    async favorite(contentId) {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        this.favoriteItem.contentId = contentId
        await axios.post(`api/favorite/add-favorite/${localStorage.getItem("patientId")}`, this.favoriteItem)
        this.favoriteMap[contentId] = true
      } catch (error) {
        console.log(error)
      }
    },
    async unfavorite(contentId) {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        var response = await axios.get(`/api/favorite/user/${localStorage.getItem("patientId")}`);
        this.userFavorites = response.data;
        const favoriteId = this.userFavorites.find(favorite => favorite.contentID === contentId).favoriteID;
        await axios.delete(`api/favorite/delete-favorite/${favoriteId}`)
        this.favoriteMap[contentId] = false
      } catch (error) {
        console.log(error)
      }
    },
    setInitialSlide() {
      console.log("Content id: ", this.contentId)
      console.log("Slide items: ", this.items)
      if (this.contentId) {
        const index = this.items.findIndex(item => item.pageContentId === this.contentId);
        console.log("Index: ", index)
        if (index !== -1) {
          this.currentSlide = index;
          console.log(this.currentSlide)
        }
      }else{
        console.log("Content id is not")
      }
    },
    openLink(link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    },
  },
  watch: {
    currentSlide() {
      this.updateCarouselHeight();
    },
    items(){
      this.setInitialSlide();
    }
  },
  mounted() {
    this.updateCarouselHeight();
    this.updateVideoWidth();
    window.addEventListener('resize', this.updateCarouselHeight);
    window.addEventListener('resize', this.updateVideoWidth);
    console.log(this.items)
    console.log(this.contentId)
    this.fetchFavorites();
  },
};
</script>

<style scoped>
.no-decoration {
  text-decoration: none;
  color: #000000de
}
</style>